import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center flex-row py-4" }
const _hoisted_3 = { class: "asociation d-flex align-items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-white" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "menu text-white" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: `sign-in`,
    class: "text-white"
  }, "Volver atrás")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    style: _normalizeStyle([{"background-color":"#33106b"}, { background: _ctx.backgroundGradient }]),
    class: "sticky-top"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.avatars?.horizontal_white)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                alt: "Logo",
                src: `${_ctx.REPO}/${_ctx.avatars?.horizontal_white}`,
                class: "h-100px h-lg-100px"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _hoisted_6
      ])
    ])
  ], 4))
}